import React, { useState, useEffect, useRef, useMemo } from "react";
import clsx from "clsx";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import {
  mediaQueries,
  // dataMap
} from "../../constant";

import { imgMapIndonesia } from "../../assets/images";
import styles from "./styles.module.scss";

// const durationAnimation = 3.5 + 1;
const durationAnimation = 3.5 + 1;

export default function AroundIndonesia() {
  const refHeading = useRef();
  const refMap = useRef();
  const refPinpointContainer = useRef();
  const [elTopHeading, setElTopHeading] = useState(0);
  const [elTopMap, setElTopMap] = useState(0);
  const [showElHeading, setShowElHeading] = useState(false);
  const [showElMap, setShowElMap] = useState(false);
  const [startingPoint, setStartingPoint] = useState(0);

  const [dataModPulse, setDataModPulse] = useState([]);

  const isBiggerScreen = useMediaQuery({
    query: `(min-device-width: ${mediaQueries?.miniDesktop}px)`,
  });

  const variantContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
          staggerChildren: 0.3,
        },
      },
    }),
    []
  );
  const variantContent = useMemo(
    () => ({
      offScreen: { y: 50, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
          staggerChildren: 0.3,
        },
      },
    }),
    []
  );

  const variantMap = useMemo(
    () => ({
      offScreen: { y: 100, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
          delay: 1,
        },
      },
    }),
    []
  );

  const variantPulse = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: { opacity: 1, delay: 2, duration: 0.5 },
    }),
    []
  );

  const checkScrollCondition = () => {
    if (
      window.pageYOffset > 0 &&
      elTopHeading > 0 &&
      window.pageYOffset + startingPoint > elTopHeading
    ) {
      setShowElHeading(true);
    } else {
      setShowElHeading(false);
    }
    if (
      window.pageYOffset > 0 &&
      elTopMap > 0 &&
      window.pageYOffset + startingPoint > elTopMap
    ) {
      setShowElMap(true);
    } else {
      setShowElMap(false);
    }
  };

  const dataMap = [
    // jabodetabek
    {
      title: "Jakarta",
      desc: "Juwita, CSI, Lulu, Wijaya, UD Selamat, Mega Top, Gema, Home Retail",
      left: 28,
      top: 72,
    },
    { title: "Tangerang", desc: "Akur Tetap Bersatu", left: 26, top: 70 },
    { title: "Bogor", desc: "Kharisma Kreasi Pratama", left: 29, top: 76 },
    // jawa & bali
    {
      title: "Surabaya",
      desc: "Cipto Langgeng, Mustika, Trijaya Sukses Gemilang, Toeng Makmur, Eastern Mart",
      left: 40,
      top: 75,
    },
    { title: "Yogyakarta", desc: "Fortuna", left: 35, top: 80 },
    { title: "Solo", desc: "Candi Jitu", left: 37, top: 76 },
    { title: "Purbalingga", desc: "Prima Star", left: 33, top: 77 },
    { title: "Bali", desc: "Calista Raya Abadi", left: 44, top: 82 },
    // sumatera
    { title: "Medan", desc: "Majaria Kencana Sakti", left: 7, top: 12 },
    { title: "Palembang", desc: "Sinar Luna", left: 21, top: 51 },
    { title: "Pekanbaru", desc: "CV Citra Melayu Makmur	", left: 16, top: 37 },
    { title: "Batam", desc: "Batam Sukses Mulia", left: 21, top: 35 },
    { title: "Lampung", desc: "Tanjung Mas", left: 22, top: 60 },
    { title: "Jambi", desc: "Duta Persada", left: 19, top: 45 },
    // kalimantan
    {
      title: "Pontianak",
      desc: "Mega Elektronik, Erikson Elect",
      left: 31,
      top: 37,
    },
    { title: "Samarinda", desc: "Jayamandiri Sentosa", left: 47, top: 38 },
    { title: "Banjarmasin", desc: "Khadeejah", left: 42, top: 53 },
    // sulawesi
    {
      title: "Makassar",
      desc: "PT Alpine Indo Makmur, Alaska Mandiri Cemerlang",
      left: 53,
      top: 64,
    },
    { title: "Manado", desc: "Bina Karya Sarana Bangun", left: 65, top: 23 },
  ];

  useEffect(() => {
    const setValues = () => {
      setStartingPoint(window.innerHeight * 0.85);
      if (refHeading.current) setElTopHeading(refHeading.current.offsetTop);
      if (refMap.current) setElTopMap(refMap.current.offsetTop);
    };

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, [refHeading, refMap]);

  useEffect(() => {
    document.addEventListener("scroll", checkScrollCondition, {
      passive: true,
    });

    return () => {
      document.removeEventListener("scroll", checkScrollCondition, {
        passive: true,
      });
    };
  });

  useEffect(() => {
    let interval = null;
    if (interval) clearInterval(interval);

    function addAnimation() {
      if (refPinpointContainer) {
        refPinpointContainer.current.classList.remove("animationMap");
        setTimeout(() => {
          refPinpointContainer.current.classList.add("animationMap");
        }, 100);
      }
    }

    function getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }

    if (showElMap) {
      let newData = [];

      for (let i = 0; i < dataMap?.length; i++) {
        if (getRandomInt(10) > 5) newData.push(dataMap[i]);
        else newData.unshift(dataMap[i]);
      }

      addAnimation();
      setDataModPulse(newData);
      interval = setInterval(() => {
        addAnimation();
      }, [dataMap?.length * durationAnimation * 1000]);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [showElMap]);

  return (
    <div className={clsx("mt-12", styles.aroundIndonesia)}>
      <motion.div
        ref={refHeading}
        variants={variantContainer}
        initial="offScreen"
        whileInView={showElHeading ? "onScreen" : "offScreen"}
        // viewport={{ once: true }}
        className={clsx("overflow-hidden py-12", styles.container)}
      >
        <motion.h2
          variants={variantContent}
          className="headline-remo text-4xl lg:text-5xl text-center"
        >
          Agen kami berada di seluruh <span className="lg:block" /> Indonesia
        </motion.h2>
        <motion.p
          variants={variantContent}
          className={clsx(
            "mt-4 lg:mt-8 mx-auto w-4/5 lg:w-3/5 text-base lg:text-xl text-center",
            styles.subTitle
          )}
        >
          Lebih dekat dengan Anda melalui agen agen kami yang tersebar di
          seluruh Indonesia.
        </motion.p>
        <motion.div
          ref={refMap}
          variants={variantMap}
          initial="offScreen"
          whileInView={showElMap ? "onScreen" : "offScreen"}
          className="relative mt-6 lg:mt-12"
        >
          <img src={imgMapIndonesia} alt="img-map_indonesia" />
          <motion.ul
            ref={refPinpointContainer}
            className={clsx(
              "overflow-hidden absolute h-full w-full top-0 right-0 bottom-0 left-0",
              styles.pinpointContainer
              // {
              //   animationMap: showElMap,
              // }
            )}
          >
            {dataModPulse?.map((item, index) => (
              <motion.li
                variants={variantPulse}
                initial="offScreen"
                whileInView="onScreen"
                key={index}
                className="select-none absolute"
                style={{ top: `${item?.top}%`, left: `${item?.left}%` }}
              >
                <div
                  className={clsx(
                    "relative rounded-full w-1.5 md:w-2 lg:w-3.5 h-1.5 md:h-2 lg:h-3.5",
                    styles.pulse
                  )}
                >
                  <div
                    className="absolute rounded-full"
                    style={{
                      animationDelay: `${index * durationAnimation}s`,
                    }}
                  />
                </div>
                {/* {isBiggerScreen && ( */}
                <motion.div
                  className={clsx("relative z-20", styles.containerPulse, {
                    "-translate-y-full": item?.top > 50,
                    "-translate-y-full translate-x-2":
                      item?.top > 50 && item?.left < 50,
                    "ml-2": item?.left < 50,
                    "mr-2 -translate-x-full": item?.left > 50,
                  })}
                  style={{
                    animationDelay: `${index * durationAnimation}s`,
                  }}
                >
                  <div
                    className={clsx(
                      "py-1 md:py-2 px-4 rounded-md",
                      styles.contentPulse
                    )}
                  >
                    <motion.h4 className="text-white font-bold">
                      {item?.title}
                    </motion.h4>
                    <p
                      className={clsx("text-white text-sm", {
                        // [styles.setMaxWidth]: item?.desc?.length > 30,
                      })}
                    >
                      {item?.desc}
                    </p>
                  </div>
                </motion.div>
                {/* )} */}
              </motion.li>
            ))}
          </motion.ul>
        </motion.div>
      </motion.div>
    </div>
  );
}
